__turbopack_context__.v({
  "qrCode": "styles-module-scss-module__T55zSW__qrCode",
  "qrCodeContainer": "styles-module-scss-module__T55zSW__qrCodeContainer",
  "qrCodeContainerDarkMode": "styles-module-scss-module__T55zSW__qrCodeContainerDarkMode",
  "qrCodeWrapper": "styles-module-scss-module__T55zSW__qrCodeWrapper",
});
